module.exports = __webpack_public_path__ + "static/media/no_reply.18a875f6.png";